import { render, staticRenderFns } from "./dias-laborales-editar.vue?vue&type=template&id=b9f5f214&scoped=true&"
import script from "./dias-laborales-editar.vue?vue&type=script&lang=js&"
export * from "./dias-laborales-editar.vue?vue&type=script&lang=js&"
import style0 from "./dias-laborales-editar.vue?vue&type=style&index=0&id=b9f5f214&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9f5f214",
  null
  
)

export default component.exports